export default __webpack_public_path__ + "static/media/check.f288a87a.svg";